<div class="header flex flex-row !justify-between px-2">
  <p
    [matTooltip]="title"
    class="max-w-[500px] whitespace-nowrap overflow-hidden text-ellipsis"
    i18n
    >
    {{ title }}
  </p>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<form [formGroup]="formGroup" class="flex flex-col overflow-hidden flex-1 p-0">
  <div
    class="flex-box w-full h-full flex items-center border-b border-solid border-[#616161]"
    >
    <div
      class="w-1/2 h-full p-5 overflow-y-auto border-r border-solid border-[#616161]"
      >
      <div class="flex justify-between mb-2 text-xs">
        <span i18n>
          上次編輯者:
          {{ getLastEditorAccountId() | account }}
        </span>
        <span i18n>
          上次編輯時間:
          {{ getLastEditTime() | moment: 'YYYY-MM-DD HH:mm' }}
        </span>
      </div>
      <div
        class="my-2 p-3 pb-4 border border-solid border-[#616161] rounded-md"
        >
        <div class="flex items-center">
          <div class="w-[170px]">
            <div class="flex items-center">
              <span i18n>訊息資料夾</span>
            </div>
          </div>
          <div class="flex-1 ml-0">
            <mat-form-field
              legacyAppearance
              class="w-full"
              *asyncJob="folders$; let folders; empty: empty"
              >
              <mat-select formControlName="folderId">
                @for (folder of folders; track folder.id) {
                  <mat-option [value]="folder.id">
                    {{ folder.name }}
                  </mat-option>
                }

                <div
                  class="w-[220px] flex justify-center items-center py-3 px-1 cursor-pointer hover:bg-[#585858]"
                  (click)="$event.stopPropagation(); createFolder()"
                  >
                  <mat-icon class="!mr-1">add</mat-icon>
                  <span i18n>建立訊息資料夾</span>
                </div>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="flex items-center">
          <div class="w-[170px]">
            <div class="flex items-center">
              <span i18n>訊息名稱</span>
            </div>
          </div>
          <div class="flex-1 ml-0">
            <mat-form-field legacyAppearance>
              <input matInput formControlName="name" />
              @if (name.invalid) {
                <mat-error i18n>
                訊息名稱不能為空
              </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/2 h-full">
      @if (!loading) {
        <ms-preview
          [package]="package"
          mode="EDIT"
          class="h-[calc(100%-60px)] w-full"
        ></ms-preview>
        <div class="p-2">
          <ms-toolbar [package]="package"></ms-toolbar>
        </div>
      }
    </div>
  </div>
  <div class="flex items-center justify-between p-4 w-full">
    <button
      mat-raised-button
      color="primary ml-auto"
      [disabled]="formGroup.invalid"
      (click)="save()"
      >
      <span i18n> 儲存 </span>
    </button>
  </div>
</form>
<ng-template #empty></ng-template>
